import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-white svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Stockholm-icons-/-General-/-Trash",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        id: "bound",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z",
        id: "round",
        fill: "#000000",
        "fill-rule": "nonzero"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z",
        id: "Shape",
        fill: "#000000",
        opacity: "0.3"
      })
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_3))
}